import gsap, { Power2 } from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

import { Ease } from '../_app/cuchillo/utils/Ease';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { ScrollItem__BlockDefault } from './ScrollItem__BlockDefault';

export class ScrollItem__BlockVision extends ScrollItem__BlockDefault {
  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);
  }

  setAnimations() {
    super.setAnimations();

    const tempArr = [];

    const itemsText = GetBy.selector('.__item', this.item);
    for (let index = 0; index < itemsText.length; index++) {
      const elems = GetBy.selector('.text p', itemsText[index]);
      const temp = new SplitText(elems, {
        type: 'lines'
      }).lines;
      new SplitText(elems, {
        type: 'lines',
        linesClass: 'line-parent'
      });
      gsap.set(temp, { y: '100%' });
      tempArr.push(temp);
    }

    this.itemsText = tempArr;
  }

  showFunction() {
    super.showFunction();

    let delay2 = .5;
    for (let j = 0; j < this.itemsText.length; j++) {
      const item = this.itemsText[j];
      for (let i = 0; i < item.length; i++) {
        const text = item[i];
        gsap.to(text, {
          y: 0,
          delay: delay2 + i * .1,
          duration: 1.5,
          ease: Ease.EASE_CUCHILLO_IN_OUT
        });
      }

      delay2 += .2;
    }
  }
}

Scroll._registerClass('BlockVision', ScrollItem__BlockVision);
